import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'
import { LOGIN_PAGE, MAIN_PAGE } from './constants.guard'
import { checkDevice } from '@/utils/common.function'

// 사용자의 로그인여부에 따른 처리.(ex. 로그인필요메뉴 로그인여부 or jwt토큰 체크)
export function createPermissionGuard(router) {
  router.beforeEach(async (to) => {
    const CMSYAUTHstore = useCMSYAUTHstore()

    if ($nvBridge.isReady && CMSYAUTHstore?.$persistedState?.isReady) {
      await CMSYAUTHstore.$persistedState.isReady()
    }

    $nvBridge.display.resizeToAvoidBottomInset(true)

    if (to.name === 'DWLOAD-APP') {
      document.title = 'GS더프레시 앱 설치안내'
    } else {
      document.title = 'GSTHEFRESH-MOBILE-DLVR'
    }
    if (to.name !== 'AUTH-CALLBACK') {
      const redirectRoute = (routeName) => (to.name === routeName ? true : { name: routeName })

      if (!CMSYAUTHstore.getIsLoggedIn && to.meta.requireAuth !== false) {
        return redirectRoute(LOGIN_PAGE)
      } else {
        if (to.name === LOGIN_PAGE) {
          return redirectRoute(MAIN_PAGE)
        }
      }
    }
  })
}
